import { queryOptions } from '@tanstack/react-query'
import {
  getAccountingPeriods,
  getAccountingPeriodStats,
} from 'src/queries/organizations/accountingPeriods/accountingPeriods.network'

export const accountingPeriodQueryKeys = {
  all: () => ['organizations', 'accounting-periods'] as const,
  list: (organizationId: string | undefined) =>
    [...accountingPeriodQueryKeys.all(), 'list', organizationId] as const,
  stats: (organizationId: string | undefined, periodId: string | undefined) =>
    [
      ...accountingPeriodQueryKeys.all(),
      'stats',
      organizationId,
      periodId,
    ] as const,
}

const getPeriodsForOrganization = (organizationId: string | undefined) => {
  if (!organizationId) {
    throw new Error('Accounting periods organizationId is required')
  }
  return getAccountingPeriods(organizationId)
}

const getStatsForPeriod = (
  organizationId: string | undefined,
  periodId: string | undefined,
) => {
  if (!organizationId || !periodId) {
    throw new Error(
      'Accounting period stats organizationId and periodId are required',
    )
  }
  return getAccountingPeriodStats(organizationId, periodId)
}

export const accountingPeriodQueries = {
  list: (organizationId: string | undefined) =>
    queryOptions({
      queryKey: accountingPeriodQueryKeys.list(organizationId),
      queryFn: () => getPeriodsForOrganization(organizationId),
      enabled: Boolean(organizationId),
      staleTime: 5 * 60 * 1000,
    }),
  stats: (organizationId: string | undefined, periodId: string | undefined) =>
    queryOptions({
      queryKey: accountingPeriodQueryKeys.stats(organizationId, periodId),
      queryFn: () => getStatsForPeriod(organizationId, periodId),
      enabled: Boolean(organizationId && periodId),
      staleTime: 30 * 1000,
    }),
}
